module.exports = __webpack_public_path__ + "static/media/POLIESTER-ALGODON-Min.5cbc3aaf.jpg";